import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import { NavigateButtonProps } from "../types/GamifiedQuiz.type";

export const NavigateButton: React.FC<NavigateButtonProps> = ({
  design,
  sectionNo,
  setSectionNo,
  GeneralFunctions,
  setGamifiedQuiz,
  formSubmitHandler,
  goToNextSection,
  isV1Api,
  translatedData,
  translatedButton,
  currentSection,
  setCurrentSection,
  totalSectionsPerSectionQuestion,
  themeManager,
  formData 
}) => {
  const shouldShowSubmit = (currSection: number, totalSections: number) => {
    return currSection >= totalSections - 1 || !formData?.length;
  };

  const getButtonText = (currSection: number, totalSections: number) => {
    if (shouldShowSubmit(currSection, totalSections)) {
      if (isV1Api && translatedData.length > 0) {
        return translatedButton;
      }
      return "Submit";
    }
    return "Next";
  };

  return (
    <>
      {design?.length > 0 ? (
        <div className="gamified-quiz-header-ques-cancel-next">
          <button
            onClick={() => {
              if (sectionNo > 0) {
                setSectionNo(sectionNo - 1);
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_previous_section_button_clicked",
                  "gamifiedquiz"
                );
              } else {
                setGamifiedQuiz(false);
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_cancel_button_clicked",
                  "gamifiedquiz"
                );
              }
            }}
            type="button"
            className="cancel-btn"
            style={themeManager.getButtonStyles().secondary}
          >
            {sectionNo > 0 ? "Previous" : "Cancel"}
          </button>

          <PrimaryButton
            type="button"
            onClick={() => {
              const totalSections = Object.keys(design);

              if (sectionNo < totalSections.length - 1) {
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_next_section_button_clicked",
                  "gamifiedquiz"
                );
                setSectionNo(sectionNo + 1);
              } else {
                formSubmitHandler();
              }
            }}
            disabled={!goToNextSection}
            className="q-onb-main-btn2"
            style={themeManager.getButtonStyles().primary}
          >
            {sectionNo >= design.length - 1
              ? isV1Api
                ? translatedData.length > 0
                  ? translatedButton
                  : ""
                : "Submit"
              : "Next"}
          </PrimaryButton>
        </div>
      ) : (
        <div className="gamified-quiz-header-ques-cancel-next">
          <button
            onClick={() => {
              if (currentSection > 0) {
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_previous_section_button_clicked",
                  "gamifiedquiz"
                );
                setCurrentSection(currentSection - 1);
              } else {
                setGamifiedQuiz(false);
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_cancel_button_clicked",
                  "gamifiedquiz"
                );
              }
            }}
            type="button"
            className="cancel-btn"
            style={themeManager.getButtonStyles().secondary}
          >
            {currentSection > 0 ? "Previous" : "Cancel"}
          </button>

          <PrimaryButton
            type="button"
            onClick={() => {
              if (!shouldShowSubmit(currentSection, totalSectionsPerSectionQuestion)) {
                GeneralFunctions.fireTrackingEvent(
                  "quest_gamifiedquiz_next_section_button_clicked",
                  "gamifiedquiz"
                );
                setCurrentSection(currentSection + 1);
              } else {
                formSubmitHandler();
              }
            }}
            disabled={!goToNextSection}
            className="q-onb-main-btn2"
            style={themeManager.getButtonStyles().primary}
          >
            {getButtonText(currentSection, totalSectionsPerSectionQuestion)}
          </PrimaryButton>
        </div>
      )}
    </>
  );
};